<script>
    /** @type {number} Nombre à formater */
    export let number;
    /** @type {('currency')} Format à appliquer */
    export let type = "currency";
    /** @type [string] Langue à utiliser */
    export let locale = "fr";

    export let subs = false;
    export let noZero = false;

    number = (subs && number > 0) ? -number : number;

    let formattedNumber = new Intl.NumberFormat(locale, {
        style: type,
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);

    if (noZero && (number === 0 || number === 0.0)) {
        formattedNumber = "";
    }
</script>

<!--
     @component
     Affiche un nombre dans le format souhaité

     Actuellement ne gère que le format monétaire
-->
<span>{formattedNumber}</span>

<style>
    span {
        font-variant-numeric: tabular-nums;
    }
</style>
